import mime from 'mime-db';

export const CONVERT_EXTENSIONS = [
  'epub',
  'ppt',
  'pptx',
  'doc',
  'docx',
  'png',
  'jpg',
  'jpeg',
  'tiff',
  'bmp',
  'heic',
  'epub',
];

export const IMAGES_EXTENSIONS = ['png', 'jpg', 'jpeg', 'tiff', 'bmp', 'heic'];

export const getFileExtension = (fileType: string) => {
  const extension = mime[fileType ?? '']?.extensions?.[0];
  return extension;
};
